import apiClient from "../api/client";
import {
  LanguageDto,
  CreateLanguageDto,
  UpdateLanguageDto,
  UpdateLanguageStatusDto,
  PagedResultDto
} from "../types/languagetypes";

export const getLanguages = (
  search: string,
  status: "all" | "active" | "inactive",
  limit = 10,
  offset = 0
) =>
  apiClient.get<PagedResultDto<LanguageDto>>(
    "/api/languages",
    {
      params: {
        search,
        status,
        limit,
        offset,
      },
    }
  );

export const getActiveLanguages = () =>
  apiClient.get<LanguageDto[]>("/api/languages/active");

export const getLanguageById = (guid: string) =>
  apiClient.get<LanguageDto>(`/api/languages/${guid}`);

export const createLanguage = (dto: CreateLanguageDto) =>
  apiClient.post("/api/languages/create", dto);

export const updateLanguage = (
  guid: string,
  dto: UpdateLanguageDto
) =>
  apiClient.put(`/api/languages/${guid}`, dto);

export const updateLanguageStatus = (
  guid: string,
  active: boolean
) =>
  apiClient.put(
    `/api/languages/${guid}/status`,
    { active } as UpdateLanguageStatusDto
  );